<template>
  <v-ons-page modifier="notoolbar">

    <div class="content">

      <div class="content--perfparams">

        <section class="section--perfparams"></section>
        <section ref="header">

          <header>
            <div class="toolbar__left">
              <v-ons-toolbar-button @click="pageStack.pop()">
                <v-ons-icon icon="chevron-down"></v-ons-icon>
              </v-ons-toolbar-button>
            </div>
            <div class="toolbar__center toolbar__title">
              <v-ons-toolbar-button v-if="multiActionSheet.length" @click="showActionSheet = true" modifier="perfrecolte">
                <span>{{ fermeLabel }}</span>
                <v-ons-icon icon="angle-down"></v-ons-icon>
                <div v-if="multiNotif" class="notification">{{ multiNotif }}</div>
              </v-ons-toolbar-button>
              <v-ons-toolbar-button v-else-if="isTech" @click="showSelectClient" modifier="perfrecolte">
                <span>{{ user.nom.toUpperCase() }} {{ user.prenom }}</span>
                <v-ons-icon icon="angle-down"></v-ons-icon>
              </v-ons-toolbar-button>
              <template v-else>
                {{ fermeLabel }}
              </template>
            </div>
            <div class="toolbar__right"></div>
          </header>

          <img :src="$getBadgeAsset(nbFeuille)">

          <v-ons-list v-if="badgeInfos" modifier="inset perfbadge">
            <v-ons-list-item :modifier="'chevron ' + badgeInfos.color" @click="showBadgeCTA">
              <div class="center">
                <span class="list-item__title">
                  {{ badgeInfos.label }}
                </span>
                <span class="list-item__subtitle">
                  {{ badgeInfos.cta }}
                </span>
              </div>
            </v-ons-list-item>
          </v-ons-list>

        </section>

        <v-ons-list modifier="noborder perflist">
          <v-ons-list-item modifier="chevron perfsimple" tappable @click="showPerso">
            Mes informations personnelles
          </v-ons-list-item>

          <v-ons-list-item modifier="chevron perfsimple" tappable @click="showFerme">
            Mon exploitation
          </v-ons-list-item>

          <v-ons-list-item modifier="chevron perfsimple" tappable @click="showNegoceRequest">
            Mes OS
          </v-ons-list-item>

          <v-ons-list-item v-if="isForm" modifier="chevron perfsimple" tappable @click="showFormList()">
            Mes documents
          </v-ons-list-item>

          <v-ons-list-item v-if="isWebView" modifier="chevron perfsimple" tappable @click="checkPushOk">
            {{ isPushKo ? 'Activer' : 'Paramétrer' }} les notifications
            <v-ons-progress-circular v-show="isLoading == 'push'" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          </v-ons-list-item>

          <v-ons-list-item v-if="isWebView" modifier="chevron perfsimple" tappable @click="$redirectToStore()">
            Donner 5 étoiles à Perfarmer
          </v-ons-list-item>
        </v-ons-list>

        <v-ons-list-title modifier="perflist">Besoin d'aide ?</v-ons-list-title>

        <v-ons-list modifier="noborder">
          <v-ons-list-item modifier="perfsimple" tappable @click="openCrisp(true)">
            <v-ons-icon icon="fa-life-ring"></v-ons-icon>&nbsp;
            Centre d'aide&nbsp;
            <v-ons-progress-circular v-show="isLoading == 'helpdesk'" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          </v-ons-list-item>

          <v-ons-list-item modifier="perfsimple" tappable @click="openCrisp(false)">
            <v-ons-icon icon="fa-comments"></v-ons-icon>&nbsp;
            Chatter avec Perfarmer&nbsp;
            <v-ons-progress-circular v-show="isLoading == 'chat'" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          </v-ons-list-item>
        </v-ons-list>

        <footer class="footer--perfbutton">
          <p>
            <span>
              Version {{ $appVersion }}
            </span>
          </p>
        </footer>

      </div>

    </div>

    <v-ons-action-sheet :modifier="$mdModifier" :visible.sync="showActionSheet" cancelable title="Changer de compte">
      <v-ons-action-sheet-button :modifier="$mdModifier" v-for="infosMulti in multiActionSheet" :key="infosMulti.id"
                                 @click="changeMulti(infosMulti.id)" :style="{ 'font-weight': infosMulti.id == user.id ? 'bold' : 'normal' }">
        {{ infosMulti.label }}
        <div v-if="infosMulti.notif" class="notification">{{ infosMulti.notif }}</div>
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="isTech" :modifier="$mdModifier" key="client" @click="showSelectClient">
        Sélectionner un agriculteur
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="! $md" @click="showActionSheet = false">Fermer</v-ons-action-sheet-button>
    </v-ons-action-sheet>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from '../store.js';

import AppClientSelect from './ClientSelect.vue';
import AppAccueil from './Accueil.vue';
import AppParamsPerso from './ParamsPerso.vue';
import AppParamsFerme from './ParamsFerme.vue';
import AppNegoceRequest from './NegoceRequest.vue';
import AppParamsFormList from './ParamsFormList.vue';
import AppChat from './Chat.vue';

import { Crisp } from 'crisp-sdk-web';

export default {
  mixins: [mixinsCommons],
  props: ['pageStack'],
  data() {
    return {
      initInfos: '',
      showActionSheet: false,
      isLoading: '',
      state: store.state,
      data: store.data
    }
  },
  computed: {
    user() {
      return this.state.user;
    },
    fermeLabel() {
      return this.getFermeLabel(this.user);
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    isTech() {
      return this.negoce[0] && this.negoce[0].is_tech;
    },
    multiActionSheet() {
      var campagneCurrent = this.user.campagne;
      var campagneDefaut = this.data.cours.campagne;
      var idUser = this.user.id.toString();
      idUser = idUser.substring(0, idUser.length - 4);
      var list = {};
      var multi = this.state.multi;
      for (const id in multi) {
        var idMulti = id.toString();
        idMulti = idMulti.substring(0, idMulti.length - 4);
        if(idMulti == idUser){
          continue;
        }        
        var multiUser = multi[id];
        if(! list[idMulti]){
          list[idMulti] = {
            label: multiUser.label,
            campagne: multiUser.campagne,
            id: id,
            notif: 0
          };
        }
        if(multiUser.campagne == campagneCurrent){
          list[idMulti].campagne = multiUser.campagne;
          list[idMulti].id = id;
        } else if(list[idMulti].campagne != campagneCurrent){
          if(multiUser.campagne == campagneDefaut){
            list[idMulti].campagne = multiUser.campagne;
            list[idMulti].id = id;
          }
        }
        list[idMulti].notif += multiUser.nbNotif;
      }
      list = Object.values(list);
      if(list.length){
        list.unshift({
          label: this.fermeLabel,
          campagne: campagneCurrent,
          id: this.user.id,
          notif: 0
        });
      }
      return list;
    },
    multiNotif() {
      return this.multiActionSheet.reduce((result, item) => { return result + item.notif; }, 0);
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    badgeInfos() {
      /*
      if (this.nbFeuille == 0) {
        return {
          label: '1ère feuille',
          color: 'perfbgjaune',
          cta: 'Configurez votre compte'
        };
      }
      */
     if (this.nbFeuille == 1) {
        return {
          label: '2ème feuille',
          color: 'perfbgorange',
          cta: 'Créez une alerte'
        };
      }
      if (this.nbFeuille == 2) {
        return {
          label: '3ème feuille',
          color: 'perfbgrouge',
          cta: 'Enregistrez une vente'
        };
      }
      /*
      if (this.nbFeuille == 3) {
        return {
          label: 'Ciel bleu',
          color: 'perfbgbleu',
          cta: 'Parrainez un ami'
        };
      */
      return null;
    },
    isForm() {
      return this.negoce.reduce((result, item) => { return result || item.form; }, false);
    },
    isPushKo() {
      return this.state.push_ok != null && ! this.state.push_ok;
    },
    isWebView(){
      return this.$ons.platform.isWebView();
    }
  },
  methods: {
    showSelectClient() {
      this.showActionSheet = false;
      this.pageStack.push({
        extends: AppClientSelect,
        data() {
          return {
            workflow: 'campagne'
          }
        }
      });
    },
    changeMulti(idMulti) {
      this.showActionSheet = false;
      if(idMulti != this.user.id){
        this.pageStack.splice(-1, 1, {
          extends: AppAccueil,
          data() {
            return {
              idMulti: idMulti
            }
          },
          onsNavigatorOptions: {
            animation: 'fade-ios'
          }
        });
        this.sendTrackEvent('multi ' + idMulti);
      }
    },
    showBadgeCTA() {
      if(this.nbFeuille == 1){
        this.$emit('change-multi', {
          idMulti: this.user.id,
          initPath: this.user.id + '/h/nd/nd/a'
        });
      } else if(this.nbFeuille == 2) {
        this.$emit('change-multi', {
          idMulti: this.user.id,
          initPath: this.user.id + '/v/nd/nd'
        });
      } else {
        this.pageStack.pop();
      }
    },
    showPerso() {
      this.pageStack.push({
        extends: AppParamsPerso,
        data() {
          return {
            isParams: true
          }
        }
      });
    },
    showFerme() {
      this.pageStack.push({
        extends: AppParamsFerme,
        data() {
          return {
            workflow: 'params'
          }
        }
      });
    },
    showNegoceRequest() {
      this.pageStack.push(AppNegoceRequest);
    },
    showFormList(initInfos) {
      this.pageStack.push({
        extends: AppParamsFormList,
        data() {
          return {
            initInfos: initInfos
          }
        },
      });
    },
    openCrisp(isHelpdesk, articleId) {
      Crisp.user.setEmail(this.user.email);
      Crisp.user.setPhone(this.user.tel);
      Crisp.user.setNickname(this.user.prenom + ' ' + this.user.nom);
      Crisp.user.setCompany(this.user.ferme.nom);
      var segments = [
        'v' + this.$appVersion,
        this.isWebView ? (this.$ons.platform.isIOS() ? 'ios' : 'android') : 'webapp'
      ];
      if(this.$device) {
        segments.push(this.$device.model);
      }
      Crisp.session.setSegments(segments, true);

      if(this.$ons.platform.isIOS()){
        this.pageStack.push({
          extends: AppChat,
          data() {
            return {
              isHelpdesk: isHelpdesk,
              articleId: articleId
            }
          },
        });
      } else {
        if(isHelpdesk){
          this.isLoading = 'helpdesk';
        } else {
          this.isLoading = 'chat';
        }
        Crisp.chat.onChatOpened(() => {
          this.isLoading = '';
        });
        this.$showCrisp(Crisp, isHelpdesk, articleId);
      }
    },
    checkPushOk(){
      if (window.FirebasePlugin) {
        window.FirebasePlugin.hasPermission(function(hasPermission){
          var infoMsg = "Les notifications push sont bloquées. Vous pouvez les activer depuis les paramètres du téléphone (section Notifications).";
          if(hasPermission){
            this.setPushToken();
          } else if(this.$md) {
            this.handleError({ is_custom: true, message: infoMsg }, '', true);
          } else {
            window.FirebasePlugin.grantPermission(function (hasPermission) {
              if(hasPermission){
                this.setPushToken();
              } else {
                this.handleError({ is_custom: true, message: infoMsg }, '', true);
              }
            }.bind(this), function (errMsg) {
              this.handleError({ is_custom: true, message: "Erreur lors de l'activation des notifications push (" + errMsg + ")" }, '', true);
            }.bind(this));
          }
        }.bind(this));
      } else {
        // debug chrome
        this.setPushToken();
      }
    },
    setPushToken() {
      this.isLoading = 'push';
      store.state.push_ok = true;
      var send = (pushToken) => {
        var fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify({
          id: this.user.id,
          date: this.user.date,
          push_token: pushToken
        });
        fetch(this.$apiDomain + this.getPath('/params/notif'), fetchInit)
          .then(this.handleResponse)
          .then(response => {
            this.isLoading = '';
            this.$showToast('Notification de test envoyée');
          })
          .catch(error => {
            this.isLoading = '';
            if (error.status == 400 && ! this.isWebView) {
              this.$ons.notification.alert({
                modifier: this.$mdModifier,
                title: 'OUPS !',
                message: "Les notifications ne peuvent pas être configurées depuis le site mobile."
                  + " Veuillez utiliser l'application depuis votre téléphone."
              });
            } else {
              this.handleError(error, 'de la configuration', true);
            }
          });
      };
      if (window.FirebasePlugin) {
        window.FirebasePlugin.getToken(token => {
          if (token) {
            localStorage.setItem('push_token', token);
          }
          send(token || localStorage.getItem('push_token') || '');
        }, () => send(localStorage.getItem('push_token') || ''));
      } else {
        send(localStorage.getItem('push_token') || '');
      }
    }
  },
  mounted() {
    var bgEl = this.$el.querySelector('.section--perfparams');
    if(this.$ons.platform.isWebView() && this.$ons.platform.isIOS()){
      var pageHeight = this.$el.scrollHeight;
      var scrollToBottom = this.$el.querySelector('.content--perfparams').offsetHeight - pageHeight;
      var titleScrollPosition = this.$el.querySelector('ons-list-title').offsetTop - 10; // .list--perflist margin-bottom
      var style = bgEl.style;
      style.height = Math.min(
        this.$refs.header.offsetHeight,
        Math.max(0, titleScrollPosition - scrollToBottom)
      ) + 'px';
      style.padding = '0';
    } else {
      bgEl.remove();
    }
  },
  created() {
    if(this.initInfos) {
      var path = this.initInfos.split('/');
      var section = path.shift();
      if(section == 'p'){
        this.showPerso();
      } else if(section == 'f'){
        this.showFerme();
      } else if(section == 'push'){
        this.checkPushOk();
      } else if(section == 'j'){
        if(this.isForm){
          this.showFormList(path.join('/'));
        }
      } else if(section == 'h'){
        var articleId = path.shift();
        this.openCrisp(true, articleId);
      }
    }
  }
}
</script>

<style>
.section--perfparams {
    position: fixed;
    width: 100%;
    z-index: -1;
}
</style>